goog.provide("shadow.js.shim.module$src$svg$wpp$content$location_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$location_svg");
shadow.js.shim.module$src$svg$wpp$content$location_svg = shadow.js.nativeProvides["src/svg/wpp/content/location.svg"] = shadow$bridge("src/svg/wpp/content/location.svg");
module$shadow_js_shim_module$src$svg$wpp$content$location_svg.default = shadow.js.shim.module$src$svg$wpp$content$location_svg;
